import {
  constructDate,
  isValidDate,
  isWithinRange,
  getCurrentDateEastern,
  addDaysToDate,
  subtractYears,
  isDateInFuture
} from 'utils/date-time';

/**
 * Validates that a given date string is between 1/1/1900 and the current date.
 * @param date - date string to be validated
 * @returns True if the date string is a valid birth date, false otherwise
 */
export const isValidBirthDate = (date: string): boolean => {
  if (!date) {
    return false;
  }
  const birthDate = constructDate(date);
  return isValidDate(birthDate) && isWithinRange(birthDate, getMinDate(), getMaxDate());
};

export const getMinDate = () => new Date('1900/01/01 00:00');
export const getMaxDate = () => getCurrentDateEastern();

export const isBirthDateInAgeRange = (date: string, fromYear: number, toYear: number): boolean => {
  if (!date || fromYear == null || toYear == null) {
    return false;
  }
  const dobYear = Number(date.substring(6));
  if (dobYear < 1900) {
    return false;
  }

  const birthDate = constructDate(date);
  const today = getCurrentDateEastern();
  const endDate = subtractYears(today, fromYear);
  const beginDate = addDaysToDate(subtractYears(today, toYear + 1), 1);

  return isValidDate(birthDate) && !isDateInFuture(birthDate) && isWithinRange(birthDate, beginDate, endDate);
};
